const moneyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 0,
})

const preciseMoneyFormatter = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

export const numberFormatter = new Intl.NumberFormat('pt-BR')

export function formatMoney(value) {
  return moneyFormatter.format(Number(value || 0))
}

export function formatTableMoney(value) {
  return preciseMoneyFormatter.format(Number(value || 0))
}

export function formatPaymentType(value) {
  if (!value) return 'Empate'
  return value === 'convenio' ? 'Convênio' : 'Particular'
}

export function getInitials(name) {
  return name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
}

export function formatDate(value) {
  if (!value) return ''
  return new Intl.DateTimeFormat('pt-BR').format(new Date(value))
}

export function formatDuration(minutes) {
  const totalMinutes = Number(minutes || 0)
  if (totalMinutes < 60) return `${totalMinutes} min`

  const hours = Math.floor(totalMinutes / 60)
  const remainingMinutes = totalMinutes % 60
  return remainingMinutes ? `${hours}h ${remainingMinutes}min` : `${hours}h`
}

export function getNiceChartStep(maxValue) {
  if (maxValue <= 0) return 1

  const roughStep = maxValue / 5
  const magnitude = 10 ** Math.floor(Math.log10(roughStep))
  const normalized = roughStep / magnitude

  if (normalized <= 1) return magnitude
  if (normalized <= 2) return 2 * magnitude
  if (normalized <= 5) return 5 * magnitude
  return 10 * magnitude
}

export function formatChartValue(value) {
  const numericValue = Number(value || 0)
  if (numericValue >= 1000) {
    return `${new Intl.NumberFormat('pt-BR', {
      maximumFractionDigits: 1,
    }).format(numericValue / 1000)}k`
  }

  return numberFormatter.format(numericValue)
}

export function formatCPF(value) {
  if (!value) return ''
  const cpf = value.replace(/\D/g, '')
  if (cpf.length !== 11) return value
  return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

export function cleanCPF(value) {
  if (!value) return ''
  return value.replace(/\D/g, '')
}
